import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Save } from "lucide-react";
import { api } from "../utils/api";

const CATEGORIES = ["SAP", "Other Applications", "Hardware Support", "Software Support", "Network & Infrastructure", "IT Security", "Access Management", "How-to", "FAQ"];

export default function KnowledgeBaseEdit() {
  const { id } = useParams();
  const nav = useNavigate();
  const isNew = !id || id === "new";
  const [form, setForm] = useState({ title: "", content: "", category: CATEGORIES[0], tags: "", status: "published" });

  useEffect(() => {
    if (!isNew) {
      api.get(`/api/kb/articles/${id}`).then((r) => {
        const a = r.data;
        setForm({ title: a.title, content: a.content, category: a.category, tags: (a.tags || []).join(", "), status: a.status });
      });
    }
  }, [id, isNew]);

  async function save(e) {
    e.preventDefault();
    const payload = {
      title: form.title,
      content: form.content,
      category: form.category,
      tags: form.tags.split(",").map((t) => t.trim()).filter(Boolean),
      status: form.status,
    };
    try {
      if (isNew) {
        const { data } = await api.post("/api/kb/articles", payload);
        nav(`/knowledge-base/${data.id}`);
      } else {
        await api.put(`/api/kb/articles/${id}`, payload);
        nav(`/knowledge-base/${id}`);
      }
    } catch (e) {
      alert(e.response?.data?.detail || "Save failed");
    }
  }

  return (
    <form onSubmit={save} className="space-y-4 max-w-4xl">
      <Link to="/knowledge-base" className="text-sm text-brand-600 hover:underline flex items-center gap-1">
        <ArrowLeft size={14} /> Back
      </Link>
      <h1 className="text-2xl font-bold">{isNew ? "New article" : "Edit article"}</h1>
      <div className="card p-5 space-y-3">
        <div><label className="label">Title</label><input className="input" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div><label className="label">Category</label><select className="input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>{CATEGORIES.map((c) => <option key={c}>{c}</option>)}</select></div>
          <div><label className="label">Tags <span className="text-xs text-gray-400">(comma-sep)</span></label><input className="input" value={form.tags} onChange={(e) => setForm({ ...form, tags: e.target.value })} placeholder="printer, paper-jam, hp" /></div>
          <div><label className="label">Status</label><select className="input" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}><option>draft</option><option>published</option><option>archived</option></select></div>
        </div>
        <div>
          <label className="label">Content <span className="text-xs text-gray-400">(plain text or markdown-ish)</span></label>
          <textarea className="input font-mono text-sm" rows="18" required value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} />
        </div>
        <button className="btn-primary flex items-center gap-2"><Save size={14} /> Save article</button>
      </div>
    </form>
  );
}
